import React from 'react'
import { useTranslation } from 'react-i18next'
import { CisLink, GroupLink, TreeLink } from '../../app/Links'
import { getIdElement } from '../../../util/StringUtil'

const UserGedcomOwnerColumn = ({ file }) => {
  const { t } = useTranslation()
  return (
    <>
      {t('user.gedcom.contributorCisId', 'Contributor Cis ID')}:
      {!file.contributor.includes('wkc') && <CisLink userId={getIdElement(file.contributor)} />}
      {file.contributor.includes('wkc') && 'FamilySearch'}
      <br />
      {t('user.gedcom.submitterCisId', 'Submitter Cis ID')}:
      {!file.submitter.includes('wkc') && <CisLink userId={getIdElement(file.submitter)} />}
      {file.submitter.includes('wkc') && 'FamilySearch'}
      <br />
      {t('user.gedcom.tree', 'Tree')}:{file.treeId && <TreeLink treeId={file.treeId} />}
      <br />
      {t('user.gedcom.group', 'Group')}: {file.groupId && <GroupLink groupId={file.groupId} />}
    </>
  )
}

export default UserGedcomOwnerColumn
